// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1q0YN","ranges":"BmiRanges_ranges__heV9M"};